import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M6.995 21.969C6.882 21.969 6.769 21.95 6.659 21.91C6.26 21.768 5.994 21.39 5.995 20.968L5.999 17H5C3.346 17 2 15.654 2 14V5C2 3.346 3.346 2 5 2H19C20.654 2 22 3.346 22 5V14C22 15.654 20.654 17 19 17H14C13.447 17 13 16.553 13 16C13 15.447 13.447 15 14 15H19C19.552 15 20 14.552 20 14V5C20 4.449 19.552 4 19 4H5C4.449 4 4 4.449 4 5V14C4 14.552 4.449 15 5 15H7C7.266 15 7.52 15.105 7.708 15.293C7.895 15.481 8 15.735 8 16.001L7.998 18.159L10.273 15.372C10.622 14.943 11.252 14.882 11.68 15.23C12.108 15.578 12.172 16.209 11.822 16.637L7.77 21.601C7.576 21.838 7.289 21.969 6.995 21.969V21.969Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'SpeechBubble');

export default Icon;
